import { useCallback, useRef, useEffect, useState } from "react"
import { useParams } from "react-router-dom"

import api from "apis"

export default function fetchOrderStatus(WrappedComponent) {
  const FetchOrderStatus = (props) => {
    const { orderToken } = useParams()
    const [data, setData] = useState(null)
    const [error, setError] = useState("")
    const [loading, setLoading] = useState(true)
    const cancelled = useRef(false)

    const getOrderStatus = useCallback(async () => {
      if (!cancelled.current && orderToken) {
        setLoading(true)

        try {
          const response = await api.get(
            `/secure/api/v10/order/${encodeURIComponent(orderToken)}`
          )
          if (response?.data) {
            setLoading(false)
            setData(response.data)
          } else {
            throw new Error("Error on fetch order status")
          }
        } catch (err) {
          console.error(err)
          setLoading(false)
          setError("Error fetching your order. Please try again later.")
        }
      }
    }, [orderToken])

    useEffect(() => {
      getOrderStatus()
    }, [getOrderStatus])

    useEffect(() => {
      return () => (cancelled.current = true)
    }, [])

    return (
      <WrappedComponent
        data={data}
        error={error}
        loading={loading}
        {...props}
      />
    )
  }

  return FetchOrderStatus
}
